import { CountryID, CountryCode } from "@al/base-lib";

import belgiumFlag from "~/common/imgs/flags/belgium.png";
import franceFlag from "~/common/imgs/flags/france.png";
import germanyFlag from "~/common/imgs/flags/germany.png";
import italyFlag from "~/common/imgs/flags/italy.png";
import polandFlag from "~/common/imgs/flags/poland.png";
import spainFlag from "~/common/imgs/flags/spain.png";
import portugalFlag from "~/common/imgs/flags/portugal.png";
import BelgiumCircleFlag from "~/common/imgs/circleFlags/Belgium.png";
import FranceCircleFlag from "~/common/imgs/circleFlags/France.png";
import GermanyCircleFlag from "~/common/imgs/circleFlags/Germany.png";
import ItalyCircleFlag from "~/common/imgs/circleFlags/Italy.png";
import PolandCircleFlag from "~/common/imgs/circleFlags/Poland.png";
import SpainCircleFlag from "~/common/imgs/circleFlags/Spain.png";
import PortugalCircleFlag from "~/common/imgs/circleFlags/Portugal.png";

export const COUNTRY_FLAG: Partial<Record<CountryID, string>> = {
  [CountryID.BE]: belgiumFlag,
  [CountryID.FR]: franceFlag,
  [CountryID.DE]: germanyFlag,
  [CountryID.IT]: italyFlag,
  [CountryID.PL]: polandFlag,
  [CountryID.ES]: spainFlag,
};

// CountryCode 对应国旗
// 圆形国旗
export const COUNTRY_CIRCLE_FLAG = {
  [CountryCode.BE]: BelgiumCircleFlag,
  [CountryCode.FR]: FranceCircleFlag,
  [CountryCode.DE]: GermanyCircleFlag,
  [CountryCode.IT]: ItalyCircleFlag,
  [CountryCode.PL]: PolandCircleFlag,
  [CountryCode.ES]: SpainCircleFlag,
  PT: PortugalCircleFlag, // 葡萄牙
};

// 方形形国旗
export const COUNTRY_RECG_FLAG = {
  [CountryCode.BE]: belgiumFlag,
  [CountryCode.FR]: franceFlag,
  [CountryCode.DE]: germanyFlag,
  [CountryCode.IT]: italyFlag,
  [CountryCode.PL]: polandFlag,
  [CountryCode.ES]: spainFlag,
  PT: portugalFlag, // 葡萄牙
};
